"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnInterval = void 0;
var table_units_1 = require("../../../../../model/tables/secondary-structures/table-units");
var ColumnInterval = (function () {
    function ColumnInterval(width, colSpan, type) {
        this.width = width;
        this.colSpan = colSpan;
        this.type = type;
    }
    ColumnInterval.prototype.substract = function (b) {
        var colSpan = this.colSpan - b.colSpan;
        if (this.type == b.type)
            return new ColumnInterval(Math.max(0, this.width - b.width), colSpan, this.type);
        switch (this.type) {
            case table_units_1.TableWidthUnitType.FiftiethsOfPercent: return new ColumnInterval(b.width, colSpan, b.type);
            case table_units_1.TableWidthUnitType.ModelUnits: return new ColumnInterval(this.width, colSpan, this.type);
            default:
                var type = this.type == table_units_1.TableWidthUnitType.Auto || b.type == table_units_1.TableWidthUnitType.Auto ?
                    table_units_1.TableWidthUnitType.Auto : table_units_1.TableWidthUnitType.Nil;
                return new ColumnInterval(0, colSpan, type);
        }
    };
    return ColumnInterval;
}());
exports.ColumnInterval = ColumnInterval;
